module.exports = __webpack_public_path__ + "static/media/analytics.e083d905.png";